import SearchInputNew from "./styles";

export default SearchInputNew;
